var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumbs'),_vm._v(" "),_c('v-container',[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',{domProps:{"textContent":_vm._s(_vm.$t(`page_title.${_vm.$route.name}`))}}),_vm._v(" "),_c('v-card-text',[_c('registration-form',{on:{"registered":_vm.onRegistered}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }